import { useState, useEffect } from 'react';
import '../../../styles/pages/tara/taraUI/systemInstructions.scss';
import get_system_instruction_api_call from '../../../lib/api/tara/get_system_instruction_api_call';
import put_system_instruction_api_call from '../../../lib/api/tara/put_system_instruction_api_call';
import LoadingSpinner from '../../../ui/loadingSpinner/LoadingSpinner';

const SystemInstructions = () => {
  const [chatInstruction, setChatInstruction] = useState('');
  const [graphInstruction, setGraphInstruction] = useState('');
  const [loading, setLoading] = useState<
    'idle' | 'loading' | 'saving' | 'success'
  >('idle');

  useEffect(() => {
    const fetchData = async () => {
      setLoading('loading');
      try {
        const result = await get_system_instruction_api_call();
        if (result?.general) {
          setChatInstruction(result.general.chat || '');
          setGraphInstruction(result.general.graphs || '');
        }
      } catch (error) {
        console.error('Error fetching system instructions:', error);
      } finally {
        setLoading('idle');
      }
    };

    fetchData();
  }, []);

  const handleSave = async () => {
    setLoading('saving');
    try {
      const payload = {
        general: {
          chat: chatInstruction || '',
          graphs: graphInstruction || '',
        },
      };

      const result = await put_system_instruction_api_call(payload);
      if (result) {
        setLoading('success');
        setTimeout(() => setLoading('idle'), 1500);
      }
    } catch (error) {
      console.error('Error saving system instructions:', error);
      setLoading('idle');
    }
  };

  return (
    <div className='systemInstructions'>
      {loading === 'loading' && (
        <div className='systemInstructions__loader-overlay'>
          <LoadingSpinner customLoadingMsg='Loading system instructions...' />
        </div>
      )}
      <h3 className='systemInstructions__title'>System Instructions</h3>
      <div className='systemInstructions__inputs'>
        <div className='systemInstructions__input-group'>
          <label>Chat</label>
          <textarea
            value={chatInstruction}
            onChange={(e) => setChatInstruction(e.target.value)}
            placeholder='Chat instructions...'
            disabled={loading === 'loading'}
            rows={8}
          />
        </div>
        <div className='systemInstructions__input-group'>
          <label>Graph</label>
          <textarea
            value={graphInstruction}
            onChange={(e) => setGraphInstruction(e.target.value)}
            placeholder='Graph instructions...'
            disabled={loading === 'loading'}
            rows={8}
          />
        </div>
        <button
          onClick={handleSave}
          disabled={
            loading === 'saving' ||
            loading === 'loading' ||
            (chatInstruction.trim() === '' && graphInstruction.trim() === '')
          }
          className='systemInstructions__save-btn'
          data-loading={loading === 'saving' ? 'true' : 'false'}
        >
          {loading === 'saving' ? (
            <>
              <span className='systemInstructions__save-btn--spinner'></span>
              <span>Saving...</span>
            </>
          ) : loading === 'success' ? (
            'Saved!'
          ) : (
            'Save'
          )}
        </button>
      </div>
    </div>
  );
};

export default SystemInstructions;
